import React from "react";

import { Box, Button, Card, Dialog, Grid, Typography } from '@mui/material';
import { TCInput, TCSelect } from "components/TopCourtComponents/Input/TopCourtInput";
import { getPlayers } from "services/playerServices";
import { TCLabel } from "components/TopCourtComponents/Label/TopCourtLabel";
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import { orderStatusOption, orderTypeOption } from "constant/constant";
import NumberRangeInput from "components/TopCourtComponents/Input/NominalRangeFilter";
import DateRangeInput from "components/TopCourtComponents/Input/DateRangeFilter";
import { TCSelectStyle } from "components/TopCourtComponents/Input/TopCourtInput";
import { isNumericOrEmpty } from "helper/String";
import { getUrlCourtCode } from "helper/Court";

export default function ClassFilter({
    filter,
    onChangeFilter,
    clearFilter
}) {

    const loadUserOption = async (input) => {
        // if (input.length < 3) {
        //     return
        // }
        try {
            let { data, error } = await getPlayers({
                namePhoneNumber: input.replace("+", "")
            });
            if (error) throw error
            data.unshift({
                name: `${getUrlCourtCode().toUpperCase()}`,
                _id: 'admin'
            })
            if (data) {
                if (data.length <= 0) return
                return data.map(value => {
                    return {
                        label: value.name ? value.name : value.phoneNumber,
                        value: value._id
                    }
                })
            }
        } catch (error) {
            console.log(error.message || error)
            return ([])
        }
    }

    return (
        <Card sx={{ mb: 1 }}
            className="custom-card-style">
            <Box sx={{ justifyContent: 'center', alignItems: 'center' }}>
                {/* filter date, booking id, user, type, status */}
                <Grid container columnSpacing={2} sx={{ p: 2 }}>
                    <Grid item xs={12} md={3} sx={{ mb: 1 }}>
                        <DateRangeInput
                            label={'Event Date'}
                            showLabel={true}
                            startDate={filter.eventDateStart}
                            endDate={filter.eventDateEnd}
                            dateRangeType={filter.eventDateType}
                            onChangeSelect={(e) => onChangeFilter({ eventDateType: e })}
                            onChangeStartDate={(e) => onChangeFilter({ eventDateStart: e })}
                            onChangeEndDate={(e) => onChangeFilter({ eventDateEnd: e })}
                        />
                    </Grid>
                    <Grid item xs={12} md={3} sx={{ mb: 1 }}>
                        <TCInput placeHolder={'Class Name'} onChange={(e) => onChangeFilter({ name: e.currentTarget.value })} value={filter.name} label={"Class Name"} />
                    </Grid>
                    <Grid item xs={12} md={3} sx={{ mb: 1 }}>
                        <NumberRangeInput
                            disabledVariable={true}
                            showLabel={true}
                            label={"Age"}
                            placeholderStart={'Min'}
                            placeholderEnd={'Max'}
                            allowZero={false}
                            numberRangeType={filter.ageType}
                            start={filter.ageMin}
                            end={filter.ageMax}
                            onChangeSelect={(e) => onChangeFilter({ ageType: e })}
                            onChangeStart={(e) => {
                                let ageMin = e.replace(/[^0-9]/g, "");
                                if (!isNumericOrEmpty(ageMin)) return;
                                if (ageMin === filter.ageMin) return;
                                onChangeFilter({ ageMin: ageMin })}
                            }
                            onChangeEnd={(e) => {
                                let ageMax = e.replace(/[^0-9]/g, "");
                                if (!isNumericOrEmpty(ageMax)) return;
                                if (ageMax === filter.ageMax) return;
                                onChangeFilter({ ageMax: ageMax })}
                            } 
                        />
                    </Grid>
                    <Grid item xs={12} md={3} sx={{ mb: 1 }}>
                        <NumberRangeInput
                            showLabel={true}
                            label={"Fee"}
                            placeholderStart={'Min'}
                            placeholderEnd={'Max'}
                            allowZero={false}
                            numberRangeType={filter.priceType}
                            start={filter.priceMin}
                            end={filter.priceMax}
                            onChangeSelect={(e) => onChangeFilter({ priceType: e })}
                            onChangeStart={(e) => {
                                let priceMin = e.replace(/[^0-9]/g, "");
                                if (!isNumericOrEmpty(priceMin)) return;
                                if (priceMin === filter.priceMin) return;
                                onChangeFilter({ priceMin: priceMin })}
                            }
                            onChangeEnd={(e) => {
                                let priceMax = e.replace(/[^0-9]/g, "");
                                if (!isNumericOrEmpty(priceMax)) return;
                                if (priceMax === filter.priceMax) return;
                                onChangeFilter({ priceMax: priceMax })}
                            }
                        />
                    </Grid>
                    <Grid item xs={12} md={3} sx={{ mb: 1 }}>
                        <TCLabel style={{fontSize: 13, color: "rgb(133, 133, 133)"}}>Owner</TCLabel>
                        <AsyncSelect
                            styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                ...TCSelectStyle,
                            }}
                            placeholder={'Select Owner...'}
                            isClearable
                            async
                            defaultOptions
                            loadOptions={loadUserOption}
                            value={filter.user} onChange={(e) => { onChangeFilter({ user: e }) }}
                        />
                    </Grid>
                    <Grid item xs sx={{ mb: 1, textAlign: 'right' }} >
                        <Button sx={{mt: 2, border: '0.5px solid #2196f3', borderRadius: 4}}
                            onClick={clearFilter}
                        >Clear</Button>
                    </Grid>
                </Grid>
            </Box>
        </Card>
    )
}
